import { z } from 'zod';
import { CustomerStatusFilterSchema } from '@/features/stacktrace/customers/-constants';
import { CustomerPhase, CustomerStatus as CS, CustomerTier } from '@/features/stacktrace/customers/-query/type';
import { CustomerTableColumns } from './-table/type';
const tierValues = Object.values(CustomerTier) as [CustomerTier, ...CustomerTier[]];
const phaseValues = Object.values(CustomerPhase) as [CustomerPhase, ...CustomerPhase[]];

/**
 * 顧客一覧画面の URL search スキーマ。
 *
 * - status:         ステータスタブ用フィルタ ("ALL" + 3 ドメイン値)
 * - tier:           重要度ドロップダウンフィルタ (単一選択・クリア可)
 * - phase:          フェーズドロップダウンフィルタ (単一選択・クリア可)
 * - freeText:       検索 (取引先名 / code 部分一致 → API の keyword)
 * - pageIndex:      0-origin ページ番号
 * - pageSize:       1 ページあたりの件数
 * - sortColumn:     ソート対象カラム (既定: コード)
 * - orderDirection: ソート方向 (既定: 昇順)
 */
export const CustomerListPageFilterSchema = z.object({
  status: CustomerStatusFilterSchema.default(CS.ACTIVE),
  tier: z.enum(tierValues).optional(),
  phase: z.enum(phaseValues).optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(CustomerTableColumns).default(CustomerTableColumns.CODE),
  orderDirection: z.enum(['asc', 'desc']).default('asc')
});